"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _default2 = _interopRequireDefault(require("./default"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var test = _lodash.default.cloneDeep(_default2.default);

test.googleAnalyticsCode = 'UA-110840836-2';
var _default = test;
exports.default = _default;